import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { registerContributorSyncQueryClient } from '@/hooks/use-flow-socket';

/** Registers the React Query client used by global `contributorUpdated` socket handlers. */
export function useContributorSocketSync() {
  const queryClient = useQueryClient();

  useEffect(() => {
    registerContributorSyncQueryClient(queryClient);
    return () => {
      registerContributorSyncQueryClient(null);
    };
  }, [queryClient]);
}
